var stackd_config = require('./config/stackd.storage.json');
const storage = stackd_config[process.env.REACT_APP_BUILD_MODE];

export default storage;